import axiosInstance from '@/services/axiosInstance'

async function uploadPFX (base64, passwd, idEmpresa, nombreFichero) {
  if (process.env.VUE_APP_ENVIRONMENT === 'testss') {
    return new Promise((resolve, reject) => {
      resolve()
    })
  } else {
    const req = {
      url: 'api/certificados/uploadpfx',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: {
        base64: base64,
        pwd: passwd,
        idEmpresa,
        nombreFichero
      }
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { uploadPFX }
